const CONSTANTS = {
  AR: 'AR',
  EN: 'EN',
}

export const defaultLanguage = CONSTANTS.AR
export default CONSTANTS
